module.exports = __webpack_public_path__ + "img/benefits_eng.8b7b5356.jpg";